import { useEffect, useState } from "react";

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  url: string;
}

const shareTargets = [
  { icon: "ri-wechat-line", label: "微信", color: "text-secondary-700" },
  { icon: "ri-weibo-line", label: "微博", color: "text-accent-600" },
  { icon: "ri-qq-line", label: "QQ", color: "text-primary-600" },
  { icon: "ri-link", label: "链接", color: "text-foreground-700" },
];

export default function ShareModal({ open, onClose, title, url }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) setCopied(false);
  }, [open]);

  if (!open) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // 剪贴板不可用时静默降级
    }
    setCopied(true);
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-foreground-950/50 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-lg bg-background-50 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-900">分享这条爆料</h3>
            <p className="mt-1 line-clamp-2 text-sm text-foreground-500">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-3">
          {shareTargets.map((t) => (
            <button
              key={t.label}
              type="button"
              onClick={t.label === "链接" ? handleCopy : () => setCopied(false)}
              className="flex cursor-pointer flex-col items-center gap-2 rounded-lg border border-background-200 py-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <i className={`${t.icon} text-2xl ${t.color}`}></i>
              <span className="text-xs text-foreground-600">{t.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-5 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
          <i className="ri-link text-sm text-foreground-400"></i>
          <span className="min-w-0 flex-1 truncate text-xs text-foreground-600">{url}</span>
          <button
            type="button"
            onClick={handleCopy}
            className="shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {copied ? "已复制" : "复制链接"}
          </button>
        </div>
        <p className="mt-3 text-center text-xs text-foreground-400">分享为页面演示功能，无需登录即可使用</p>
      </div>
    </div>
  );
}